<template>
  <v-container style="overflow-x: auto !important">
    <v-row class="go">
      <Children
        :students="students"
        :currentBalance="currentBalance"
        :currentPoints="currentPoints"
        :wallet_status="wallet_status"
        v-on:reload="getDataFromApi"
      ></Children>

      <EmptySpace></EmptySpace>

      <MyWallet
        :currentBalance="currentBalance"
        :currentPoints="currentPoints"
        :wallet_status="wallet_status"
        :activateRecharge="activateRecharge"
      ></MyWallet>
    </v-row>
  </v-container>
</template>

<script>
import Children from "../components/Children.vue";
import MyWallet from "../components/MyWallet.vue";
import EmptySpace from "../components/EmptySpace.vue";
import HttpService from "../services/HttpService.js";
export default {
  name: "Wallet",
  components: {
    Children,
    MyWallet,
    EmptySpace,
  },
  data() {
    return {
      type: "me",
      currentBalance: 0,
      currentPoints: 0,
      wallet_status: "",
      students: [],
      activateRecharge: true,
    };
  },
  methods: {
    getDataFromApi() {
      HttpService.get("wallet/getWalletDetailsByJoin", "", true).then(
        (response) => {
          console.log("getWalletDetailsByJoin RES = ", response);
          // this.currentBalance = parseInt(response.data.data.current_balance);
          // this.currentPoints = parseInt(response.data.data.current_points);
          this.currentBalance = response.data.data.current_balance;
          console.log("currentBalance = ", this.currentBalance);

          this.currentPoints = response.data.data.current_points;
          this.wallet_status = response.data.data.wallet_status;
          this.students = response.data.data.students;
        }
      );
    },
  },

  mounted() {
    this.getDataFromApi();
  },
};
</script>

<style>
@media (max-width: 600px) {
  .go {
    flex-direction: column-reverse !important;
  }
  /* #wrapper {
    left: 25px;
  }
  #wrapper.active {
    // padding-left: 125px;
    left: 125px !important;
  }
  #wrapper.activeRtl {
    // padding-left: 125px;
    right: 125px !important;
  } */
}
</style>
